/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Work_Activity_File_Not_AttachableInputs */

const vi_error_work_activity_file_not_attachable = /** @type {(inputs: Error_Work_Activity_File_Not_AttachableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Một tệp đính kèm không còn trên hệ thống hoặc không do bạn tải lên. Vui lòng gỡ tệp đó rồi chọn lại.`)
};

/**

* @param {Error_Work_Activity_File_Not_AttachableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_work_activity_file_not_attachable = /** @type {((inputs?: Error_Work_Activity_File_Not_AttachableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Work_Activity_File_Not_AttachableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_work_activity_file_not_attachable(inputs)
});